<template>
  <div class="subMerchant-list">
    <el-row :gutter="20" class="operate-bar">
      <el-col :span="8" align="left">
        <!-- 新增子商户按钮 -->
        <el-button v-if="hasPermission('subMerchant:edit')" icon="el-icon-plus" type="primary" @click="openAddDialog"
          v-hasPermission="'subMerchant:edit'">新增子商户</el-button>
      </el-col>
      <!-- 搜索区域 -->
      <el-col :span="16" align="right">
        <el-form :inline="true" :model="searchForm" class="search-form">
          <el-row>
            <el-form-item label="子商户ID">
              <el-input v-model="searchForm.subMchId" placeholder="请输入子商户ID" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="子商户名称">
              <el-input v-model="searchForm.subMchName" placeholder="请输入子商户名称" maxlength="50"></el-input>
            </el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="loadSubMerchants">查询</el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
          </el-row>
        </el-form>
      </el-col>
    </el-row>

    <!-- 数据表格 -->
    <el-table :data="subMerchants" border stripe style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center"></el-table-column>
      <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
      <el-table-column prop="subMchName" label="子商户名称" header-align="center"></el-table-column>
      <el-table-column prop="subMchId" label="子商户ID" header-align="center"></el-table-column>
      <el-table-column prop="isSelf" label="是否为自营主体" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isSelf === 1 ? 'success' : 'danger'">
            {{ scope.row.isSelf === 1 ? '是' : '否' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="启用状态" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status" active-color="#13ce66"
            :active-value="1" :inactive-value="0" :disabled="!hasPermission('subMerchant:edit')"
            @change="handleStatusChange(scope.row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间"
        :formatter="(row, column, cellValue) => $options.filters.formatTime(cellValue)"
        align="center" width="200"></el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="scope">
          <el-tooltip content="编辑" placement="top" v-if="hasPermission('subMerchant:edit')">
            <el-button icon="el-icon-edit" type="primary" circle v-hasPermission="'subMerchant:edit'"
              @click="openEditDialog(scope.row)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
      :page-sizes="[10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
      :total="total"></el-pagination>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="700px">
      <el-form :model="form" :rules="rules" ref="form" label-width="300px">
        <el-form-item label="子商户ID（必须与微信商户平台一致）" prop="subMchId">
          <el-input v-model="form.subMchId" style="width: 100%" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="子商户名称（建议与微信商户平台一致）" prop="subMchName">
          <el-input v-model="form.subMchName" style="width: 100%" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="是否为自营主体" prop="isSelf">
          <el-radio-group v-model="form.isSelf">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import subMerchantApi from '../../api/subMerchant';
import { hasPermission } from '../../utils/hasPermission';

export default {
  name: 'SubMerchantList',
  data() {
    // 子商户ID唯一校验
    const checkSubMchIdUnique = async (rule, value, callback) => {
      if (!value) {
        // 空值不校验（由required规则处理）
        return callback()
      }

      try {
        const params = {
          subMchId: value,
          excludeId: this.isEdit ? this.recordId : null
        }
        // 调用后端查重接口
        const response = await subMerchantApi.checkSubMchIdUnique(params)
        if (response.success && response.exists) {
          // 子商户ID已存在，返回错误提示
          callback(new Error('该子商户ID已被使用，请更换'))
        } else {
          // 子商户ID可用，验证通过
          callback()
        }
      } catch (error) {
        callback(new Error('检查失败，请稍后重试'))
      }
    }

    return {
      // 表格数据
      subMerchants: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      // 搜索表单
      searchForm: {
        subMchId: '',
        subMchName: ''
      },

      // 选中的行
      selectedIds: [],

      // 对话框
      dialogVisible: false,
      dialogTitle: '新增子商户',
      isEdit: false,
      recordId: null,
      form: {
        id: null,
        subMchId: '',
        subMchName: '',
        isSelf: 1,
        status: 0,
      },
      rules: {
        subMchId: [
          { required: true, message: '请输入子商户ID', trigger: 'blur' },
          { min: 1, max: 50, message: '子商户ID长度在 1 到 50 个字符', trigger: 'blur' },
          { validator: checkSubMchIdUnique, trigger: 'blur' }
        ],
        subMchName: [
          { required: true, message: '请输入子商户名称', trigger: 'blur' },
          { min: 1, max: 50, message: '子商户名称长度在 1 到 50 个字符', trigger: 'blur' },
        ],
        isSelf: [
          { required: true, message: '请选择是否为自营主体', trigger: 'change' },
          { type: 'number', enum: [0, 1], message: '值只能为是/否', trigger: 'change' }
        ]
      },
    }
  },
  created() {
    this.loadSubMerchants()
  },
  methods: {
    // 加载子商户列表
    loadSubMerchants() {
      // 组装请求参数
      const params = {
        subMchId: this.searchForm.subMchId,     // 搜索-子商户ID
        subMchName: this.searchForm.subMchName, // 搜索-子商户名称
        page: this.currentPage,                 // 分页-当前页
        size: this.pageSize,                    // 分页-每页条数
      };
      subMerchantApi.findAll(params).then(response => {
        if (response.success) {
          this.subMerchants = response.data.data
          this.total = response.data.total
        } else {
          this.$message.error(response.message)
        }
      }).catch(error => {
        this.$message.error('加载子商户列表失败：' + error.message)
      })
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        subMchId: '',
        subMchName: ''
      }
      this.loadSubMerchants()
    },

    // 每页条数变化时
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadSubMerchants(); // 重新加载
    },

    // 当前页变化时
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadSubMerchants(); // 重新加载
    },

    // 选择变化
    handleSelectionChange(selection) {
      this.selectedIds = selection.map(item => item.id)
    },

    // 打开新增对话框
    openAddDialog() {
      if (!hasPermission('subMerchant:edit')) {
        this.$message.error('无新增子商户权限');
        return;
      }
      this.dialogTitle = '新增子商户'
      this.isEdit = false
      this.recordId = null
      this.form = {
        id: null,
        subMchId: '',
        subMchName: '',
        isSelf: 1,
        status: 0,
      }
      this.dialogVisible = true
      // 开始处理数据
      this.stopReceiving = false;
    },

    // 打开编辑对话框
    openEditDialog(row) {
      if (!hasPermission('subMerchant:edit')) {
        this.$message.error('无编辑子商户权限');
        return;
      }
      this.dialogTitle = '编辑子商户'
      this.isEdit = true
      this.recordId = row.id
      this.form = { ...row }
      this.dialogVisible = true
    },

    handleCancel() {
      this.dialogVisible = false; // 关闭对话框
      this.$refs.form.resetFields(); // 重置表单
      this.stopReceiving = true; // 停止处理数据
    },

    // 提交表单
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.isEdit) {
            // 更新子商户
            subMerchantApi.update(this.form.id, this.form).then(response => {
              if (response.success) {
                this.$message.success(response.message || '更新成功')
                this.dialogVisible = false
                this.$refs.form.resetFields()
                this.loadSubMerchants()
              } else {
                this.$message.error(response.message)
              }
            }).catch(error => {
              this.$message.error('更新失败：' + error.message)
            })
          } else {
            // 新增子商户
            subMerchantApi.add(this.form).then(response => {
              if (response.success) {
                this.$message.success(response.message || '新增成功')
                this.dialogVisible = false
                this.$refs.form.resetFields()
                this.stopReceiving = true; // 停止处理数据
                this.loadSubMerchants()
              } else {
                this.$message.error(response.message)
              }
            }).catch(error => {
              this.$message.error('新增失败：' + error.message)
            })
          }
        }
      })
    },

    // 修改子商户状态
    handleStatusChange(row) {
      if (!hasPermission('subMerchant:edit')) {
        this.$message.error('无操作子商户权限');
        return;
      }
      this.$confirm(`确定要${row.status === 1 ? '启用' : '禁用'}该子商户吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        subMerchantApi.status(row.id, row.status).then(response => {
          if (response.success) {
            this.$message.success(response.message || '操作成功')
            this.loadSubMerchants()
          } else {
            this.$message.error(response.message)
          }
        }).catch(error => {
          row.status = row.status === 1 ? 0 : 1;
          this.$message.error('操作失败：' + error.message)
        })
      }).catch(() => {
        // 取消操作（此处可留空，仅用于捕获异常）
        row.status = row.status === 1 ? 0 : 1;
      });
    },

    hasPermission(permCode) {
      return hasPermission(permCode);
    }
  }
}
</script>

<style scoped></style>